import { ParsedToken, User } from "firebase/auth";
import React, { createContext, useReducer } from "react";
import { reducer } from "./reducer";
import { Actions } from "./types";
import { AtsFinYr } from "../components/modules/customer/financialYear/queries/types";
import { empType } from "../utils/Enum.types";

export type InitialStateType = {
  user: User | null;
  claims: ParsedToken | null;
  empLoginId: number;
  eduateId: number;
  empId: number;
  customerId: number;
  companyId: number;
  subsidiaryId: number;
  subSiteId: number;
  categoryId: number;
  itmGroupId: number;
  manufacturerId: number;
  uomId: number;
  itmId: number;
  supplierId: number;
  locationId: number;
  mrfId: number;
  mrfTransId: number;
  ActiveFinYr: AtsFinYr | null;
  emailConfigId: number;
  rfqId: number;
  rfqNo: string;
  rfqTrnSupplyId: number;
  itemLedgerId: number;
  ticketId: number;
  junctionID: number;
  empSubType: empType;
  itmDesc?: string;
  itemDetailsId: number;
  projectId: number;
  junctionType: string;
  ticketStatus: string;
  groupId: number;
  grpAssemblyId: number;
  longitude: number;
  latitude: number;
  ticketReasonId: number;
  deviceTypeID: number;
  projectExtId: number;
  ItmsChallanId: number;
};

export const initialState: InitialStateType = {
  user: null,
  claims: null,
  empLoginId: 0,
  eduateId: 0,
  empId: 0,
  customerId: 0,
  companyId: 0,
  subsidiaryId: 0,
  subSiteId: 0,
  categoryId: 0,
  itmGroupId: 0,
  manufacturerId: 0,
  uomId: 0,
  itmId: 0,
  supplierId: 0,
  locationId: 0,
  mrfId: 0,
  mrfTransId: 0,
  ActiveFinYr: null,
  emailConfigId: 0,
  rfqId: 0,
  rfqNo: "",
  itmDesc: "",
  rfqTrnSupplyId: 0,
  itemLedgerId: 0,
  ticketId: 0,
  junctionID: 0,
  empSubType: empType.SYS_ADMIN,
  itemDetailsId: 0,
  projectId: 0,
  junctionType: "",
  ticketStatus: "",
  groupId: 0,
  grpAssemblyId: 0,
  longitude: 0,
  latitude: 0,
  ticketReasonId: 0,
  deviceTypeID: 0,
  projectExtId: 0,
  ItmsChallanId: 0,
};

const AppContext = createContext<{
  state: InitialStateType;
  dispatch: React.Dispatch<Actions>;
}>({
  state: initialState,
  dispatch: () => null,
});
interface Props {
  children: React.ReactNode;
}
const AppProvider: React.FC<Props> = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <AppContext.Provider value={{ dispatch, state }}>
      {children}
    </AppContext.Provider>
  );
};

export { AppProvider, AppContext };
